const THEME_STORAGE_KEY = "app-theme";

export type Theme = "dark" | "light";

export function applyTheme(themeValue: Theme | string) {
  const value = themeValue === "light" ? "light" : "dark";
  if (typeof localStorage !== "undefined") {
    localStorage.setItem(THEME_STORAGE_KEY, value);
  }
  const root = document.documentElement;
  if (value === "light") {
    root.style.setProperty("--bg", "#f5f6f8");
    root.style.setProperty("--bg-card", "#ffffff");
    root.style.setProperty("--bg-input", "#ffffff");
    root.style.setProperty("--bg-hover", "#eef1f4");
    root.style.setProperty("--border", "#e2e6ea");
    root.style.setProperty("--text", "#1a1d21");
    root.style.setProperty("--text-muted", "#6b7280");
    root.classList.add("theme-light");
    root.classList.remove("theme-dark");
  } else {
    root.style.setProperty("--bg", "#101922");
    root.style.setProperty("--bg-card", "#111418");
    root.style.setProperty("--bg-input", "#111418");
    root.style.setProperty("--bg-hover", "#283039");
    root.style.setProperty("--border", "#1e293b");
    root.style.setProperty("--text", "#ffffff");
    root.style.setProperty("--text-muted", "#9dabb9");
    root.classList.add("theme-dark");
    root.classList.remove("theme-light");
  }
}

/** Apply theme from localStorage before first paint to avoid flash. */
export function applyThemeFromStorage() {
  const stored =
    typeof localStorage !== "undefined"
      ? localStorage.getItem(THEME_STORAGE_KEY)
      : null;
  applyTheme((stored as Theme) || "dark");
}
